import React, { lazy } from 'react';
import { CATEGORIES, MENU_PRODUCTS } from '../data/menuData';
interface CategoryGridProps {
  onSelectCategory: (category: string) => void;
}
const CATEGORY_ICONS: Record<string, string> = {
  Sándwich: '🥪',
  Wrap: '🌯',
  Cremas: '🍲',
  'Snack Bowl': '🥣',
  Niños: '👶',
  Bebidas: '🥤'
};
export function CategoryGrid({
  onSelectCategory
}: CategoryGridProps) {
  return <div className="mb-6" data-id="element-132">
      <h2 className="text-xl font-heading font-bold text-white mb-4 px-1 tracking-wide" data-id="element-133">
        ¿Qué se te antoja?
      </h2>
      <div className="grid grid-cols-2 gap-3" data-id="element-134">
        {CATEGORIES.map(category => {
        const firstProduct = MENU_PRODUCTS.find(p => p.category === category);
        const emoji = CATEGORY_ICONS[category] || '🍽️';
        return <button key={category} onClick={() => onSelectCategory(category)} className="relative rounded-2xl overflow-hidden h-32 text-left group active:scale-[0.97] transition-transform border border-gray-800" data-id="element-135">
              {firstProduct?.image ? <img src={firstProduct.image} alt={category} className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-136" /> : <div className="absolute inset-0 bg-gray-800" data-id="element-137" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" data-id="element-138" />
              <div className="absolute bottom-0 left-0 right-0 p-3" data-id="element-139">
                <span className="text-lg mb-0.5 block" data-id="element-140">{emoji}</span>
                <h3 className="text-white font-heading font-bold text-base leading-tight" data-id="element-141">
                  {category}
                </h3>
              </div>
            </button>;
      })}
      </div>
    </div>;
}